import { ComponentType, PropsWithChildren, useMemo } from 'react';
import { Button, IconButton } from '@mui/material';
import { ArrowBackIosNew as ArrowBackIosNewIcon } from '@mui/icons-material';
import { ButtonProps, CreatePathParams, useCreatePath } from 'react-admin';
import RouterLink from './RouterLink';
import { Link, useNavigate } from 'react-router-dom';

const BackButton: ComponentType<
    PropsWithChildren<{
        variant?: ButtonProps['variant'];
        fullWidth?: ButtonProps['fullWidth'];
        to?: string | CreatePathParams;
        onClick?: () => void;
        type?: 'icon' | 'default';
    }>
> = (props) => {
    const { children, to, onClick, type = 'default' } = props;
    const navigate = useNavigate();
    const createPath = useCreatePath();

    const propsToPass = useMemo(() => {
        if (onClick) {
            return { onClick };
        } else if (typeof to === 'string') {
            return { to, component: RouterLink };
        } else if (typeof to === 'object') {
            return { to: createPath(to), component: RouterLink };
        }

        return {
            onClick: () => navigate(-1),
        };
    }, [to, onClick, navigate]);

    if (type === 'icon') {
        return (
            <IconButton component={Link} {...propsToPass}>
                <ArrowBackIosNewIcon />
            </IconButton>
        );
    }

    return (
        <Button
            startIcon={<ArrowBackIosNewIcon />}
            variant={props.variant}
            fullWidth={props.fullWidth}
            {...propsToPass}
        >
            {children}
        </Button>
    );
};

export default BackButton;
